import { getChestApiUrl } from "../../helpers";
import { getHeaders } from '../helpers';
import metricsApi from '../metrics';

/**
 * Send the request to the api to buy the product, if check is true
 * then message processor goes directly to check without modifying the
 * passengers info.
 * 
 * @param {Object} selectedProduct Object of the flight selected
 * @param {Boolean} check Go directly to check
 * @param {String} session Session of the user
 */
const book = ({ selectedProduct = {}, check = false, configuration = {}, session = "" }) => {

  return new Promise((resolve, reject) => {
    if (!Object.keys(selectedProduct).length) return reject();

    if (selectedProduct.provider === "SKYSCANNER" && configuration.redirections) {
      metricsApi.register({ session, productType: 'flight', state: 'redirect' });
      return window.open(selectedProduct.booking.links, '_blank');
    } else {
      let url = `${getChestApiUrl()}/chestApi/f/results`;
      if (check) url = `${getChestApiUrl()}/chestApi/f/results/check`;

      return resolve(fetch(url, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ session, selectedProduct })
      }))
    }
  })
}

export default {
  book
}